export default {
  methods: {
    clipboard(value) {
      // make a dummy input element
      const dummy = document.createElement('input');
      // add it to the body
      document.body.appendChild(dummy);
      // set its value attribute
      dummy.setAttribute('value', value);
      // select it
      dummy.select();
      // run execCommand('copy') to copy its value
      document.execCommand('copy');
      // then remove the element
      document.body.removeChild(dummy);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/clipboard.js